import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const ApsTable = ({ apsAllReport, apsAllLoading }) => {
  const hasApsrData = apsAllReport &&
    typeof apsAllReport === "object" &&
    Object.keys(apsAllReport).length > 0;
  return (
    <div className="container-fluid">
      <div className="container-sm py-3">
        <div className="row mb-3 justify-content-center">
          <div className="col-md-6 flex-vh-center">
            <div className="card w-50 border-warning">
              <div className="card-body">
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <span className="fw-bold">APS Not Applied</span>
                  <span className="display-4">{apsAllReport?.totalApsNotApplied?.count}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 flex-vh-center">
            <div className="card w-50 border-warning">
              <div className="card-body">
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <span className="fw-bold">APS Applied</span>
                  <span className="display-4">{apsAllReport?.totalApsApplied?.count}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      {!apsAllLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="overflow-auto wb-scrollbar-w-1 mb-3"  style={{ maxHeight: "50vh" }}>
                {hasApsrData ? (
                  <table className="table table-yesgermany table-hover table-bordered">
                    <thead>
                      <tr className="text-nowrap">
                        <th>APS Status</th>
                        <th>Counts</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td>Total Students</td>
                          <td>{apsAllReport?.total_students?.count}</td>
                        </tr>
                        <tr>
                          <td>Not Updated</td>
                          <td>{apsAllReport?.not_updated?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Not Started</td>
                          <td>{apsAllReport?.aps_not_started?.count}</td>
                        </tr>
                        <tr>
                          <td>Intro APS Email</td>
                          <td>{apsAllReport?.intro_aps_call_done?.count}</td>
                        </tr>
                        <tr>
                          <td>APS/Visa Form Recieved</td>
                          <td>{apsAllReport?.form_recieved?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Form Filled</td>
                          <td>{apsAllReport?.form_filled?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Form Completed & Checklist Sent</td>
                          <td>{apsAllReport?.form_completed?.count}</td>
                        </tr>
                        <tr>
                          <td>Final File Recieved & Verified</td>
                          <td>{apsAllReport?.final_file_recieved?.count}</td>
                        </tr>
                        <tr>
                          <td>Document Sent to APS</td>
                          <td>{apsAllReport?.doc_sent_to_aps?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Certificate Follow-up</td>
                          <td>{apsAllReport?.aps_followup?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Recieved & Uploaded on dropbox</td>
                          <td>{apsAllReport?.uploaded_on_dropbox?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Recieved (Self Applied)</td>
                          <td>{apsAllReport?.aps_recieved_self?.count}</td>
                        </tr>
                        <tr>
                          <td>Foriegn Degree</td>
                          <td>{apsAllReport?.foreign_degree?.count}</td>
                        </tr>
                        <tr>
                          <td>Not Applicable</td>
                          <td>{apsAllReport?.not_applicable?.count}</td>
                        </tr>
                        <tr>
                          <td>Pursuing 12th</td>
                          <td>{apsAllReport?.pursuing?.count}</td>
                        </tr>
                        <tr>
                          <td>Rejection</td>
                          <td>{apsAllReport?.rejection?.count}</td>
                        </tr>
                        <tr>
                          <td>Self Applied</td>
                          <td>{apsAllReport?.self_applied?.count}</td>
                        </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}
      </div>
    </div>
  );
};

export default ApsTable;
